export class ProductBaseModel {
     prd_code: string
     prd_name: string
     uom: string
     price: number
     quantity: number
     stock_amount: number
     bonus: string
     tax: number
     line_type_code: string
     total: number
    
}




// WEBPACK FOOTER //
// ./src/models/product/productbase.model.ts